export const HELP_GOALS_INDIVIDUAL_LESSONS = [
  {
    title: 'Бесплатно проконсультируем',
    description:
      'На&nbsp;30-минутном созвоне проверим ваш уровень языка и&nbsp;разберем, для какой глобальной цели вам нужен английский. В&nbsp;зависимости от&nbsp;этого мы&nbsp;поможем вам выбрать формат занятий и&nbsp;подберем преподавателя.',
  },
  {
    title: 'Составим роудмэп',
    description:
      'Исходя из&nbsp;ваших целей и&nbsp;предпочтений, мы&nbsp;составим учебный план, где будет только самое необходимое и&nbsp;много практики. С&nbsp;таким роудмэпом вы&nbsp;будете наглядно видеть, какие темы предстоит пройти и&nbsp;в&nbsp;какие сроки, а&nbsp;также будете отслеживать свой прогресс',
  },
  {
    title: 'Доведем до цели',
    description:
      'Если вам нужен английский для работы, то&nbsp;на&nbsp;занятиях вы&nbsp;выучите и&nbsp;отработаете на&nbsp;практике необходимую грамматику, начнете использовать профессиональную лексику в&nbsp;речи, а&nbsp;также узнаете основы делового общения и&nbsp;переписки на&nbsp;английском. <br> А&nbsp;еще мы&nbsp;эффективно готовим к&nbsp;собеседованию на&nbsp;английском, поэтому с&nbsp;радостью сопроводим вас до&nbsp;оффера!',
    list: {
      title: 'В рамках подготовки к собеседованиям вы:',
      points: [
        'Оформите LinkedIn и&nbsp;напишете резюме на&nbsp;английском;',
        'Обсудите с&nbsp;преподавателем все интересующие вас вакансии, чтобы написать под них сопроводительные письма;',
        'Узнаете, как лучше всего отвечать на&nbsp;основные вопросы с&nbsp;собеседований, а&nbsp;также отработаете их&nbsp;на&nbsp;практике;',
        'Пройдете mock интервью с&nbsp;носителем языка, чтобы быть готовым общаться с&nbsp;настоящим рекрутером (такая практика позволяет вам выйти из&nbsp;зоны комфорта и&nbsp;трезво оценить свои коммуникативные умения перед незнакомым человеком).',
      ],
    },
  },
];

export const HOW_WE_WORK_FOR_COMPANIES = [
  {
    title: 'Бесплатная консультация',
    description:
      'Расскажите нам о&nbsp;своих целях и&nbsp;задачах, и&nbsp;мы&nbsp;предложим решение, которое идеально подойдет для вашей компании.',
  },
  {
    title: 'Тест-драйв курса',
    description:
      'Мы&nbsp;проведем бесплатное пробное занятие для вашей команды, чтобы вы&nbsp;оценили формат и&nbsp;качество обучения.',
  },
  {
    title: 'Тестирование сотрудников',
    description: 'Мы&nbsp;проверим уровень языка, чтобы сформировать максимально эффективные группы',
  },
  {
    title: 'Старт программы ',
    description:
      'Наши преподаватели начнут обучение, а&nbsp;вы&nbsp;получите первые результаты уже через несколько недель.',
  },
];
